export const Translations_en = {
    "welcomePageTitle": "Select your ",
    "lockerName": "Locker name",
    "lockerId": "Locker Id",
    "address": "Address",
    "selectBtn": "Select easybox",
    "select": "Select...",
    "county": "County",
    "city": "City",
    "easyboxNameStreet": "Easybox / street name...",
    "backToLockerList": "< Back to list",
    "favouriteLocker": "Mark as favourite",
    "removeFavouriteLocker": "Remove favourite",
    "openOnGoogleMaps": "Open on Google Maps",
    "monday": "Monday",
    "tuesday": "Tuesday",
    "wednesday": "Wednesday",
    "thursday": "Thursday",
    "friday": "Friday",
    "saturday": "Saturday",
    "sunday": "Sunday",
    "non-stop": "non-stop",
    "lockerSchedule": "Schedule",
    "seeOnMap": "See on map",
    "locationDisclaimer": "Please make sure your location is enabled and allow access when your browser/device asks for location permissions.",
    "findMeOnMap": "Find me on map",
    "searchFilters": "Search filters",
    "locationError1": "Geolocation is not supported by this browser.",
    "locationError2": "Location error: Access is denied!",
    "locationError3": "Location error: Position is unavailable!",
    "clientNotFoundErrorMsg": "Error! Client not found!",
    "sdkNotFoundErrorMsg": "Error! Locker Plugin SDK not found!",
    "search": "Search any easybox details",
    "searchBy": "You can search by:",
    "easyboxName": "Easybox name",
    "street": "Street",
    "showEasyboxList": "Show easybox list",
    "hideEasyboxList": "Hide easybox list",
    "searchError1": "Input must be between ${minLimit} and ${maxLimit} characters",
    "searchError2": "Input can't contain the special character: ${notAllowedSpecial}",
    "home": "Home",
    "work": "Work",
    "onlyPOSLockers": "Only easyboxes with POS",
    "advancedFilters": "Filters",
    "posAtLocation": "POS at location:",
    "yes": "Yes",
    "no": "No",
    "showAllTheLockersInArea": "Display all easyboxes in this area",
    "showSelectedLocker": "Show selected easybox",
    "hideSelectedLocker": "Hide selected easybox",
    "noEasyboxesFound": "No easyboxes found, please refine your search."
}